import { render, staticRenderFns } from "./HomeIndex.vue?vue&type=template&id=a94e7d1e&"
import script from "./HomeIndex.vue?vue&type=script&lang=js&"
export * from "./HomeIndex.vue?vue&type=script&lang=js&"
import style0 from "./HomeIndex.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PagsmileCard: require('/builds/pagsmile/front-end/pagsmile-web/components/PagsmileCard/components/PagsmileCard.vue').default})
